import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function MarketingApproach() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        html, body {
          overflow-x: hidden;
          max-width: 100%;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 sm:py-32 overflow-hidden flex items-center">
        {/* Background Image using img tag */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/marketing_bg.png" 
            alt="Marketing Model Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="max-w-7xl mx-auto relative z-10 w-full">

          {/* Main Heading */}
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8 leading-tight max-w-6xl">
            Marketing Model Based on Approach
          </h1>

          {/* Description */}
          <p className="text-gray-300 text-lg lg:text-xl leading-relaxed max-w-4xl mb-12">
            Understanding the right marketing approach is crucial for business success. Each model offers unique advantages tailored to different business goals, audiences, and budgets.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-3 sm:gap-4">
            <button className="px-6 sm:px-8 py-3 bg-orange-500 text-white rounded-md font-medium hover:bg-orange-600 transition">
              Explore Strategies
            </button>
            <button className="px-8 py-3 border border-white text-white rounded-md font-medium hover:bg-white hover:text-orange-500 hover:border-orange-500 transition">
              Compare Models
            </button>
          </div>

        </div>
      </section>

      {/* The Evolution of Marketing Models Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500">
        <div className="max-w-7xl mx-auto">
          
          <div className="bg-gray-800 rounded-3xl p-5 sm:p-12 lg:p-16">
            <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 items-center">
              
              {/* Left Side - Content */}
              <div className="space-y-6">
                
                {/* Main Heading */}
                <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
                  The Evolution of Marketing Models
                </h2>

                {/* First Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                  Marketing has transformed dramatically over the past decades, evolving from traditional broadcast methods to sophisticated digital strategies. Today's businesses face an unprecedented array of marketing approaches, each with distinct characteristics, costs, and potential returns.
                </p>

                {/* Second Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                  Understanding these models isn't just about knowing what they are—it's about strategically selecting and combining approaches that align with your business objectives, target audience behavior, and available resources.
                </p>

              </div>

              {/* Right Side - Image */}
              <div className="relative">
                <div className="relative rounded-2xl overflow-hidden">
                  <img 
                    src="/Assests/home_page_47.png" 
                    alt="The Marketing Evolution" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Why Your Marketing Approach Matters Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-amber-200 rounded-full opacity-30"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            Why Your Marketing Approach Matters
          </h2>

          {/* Cards Grid - 2x2 */}
          <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
            
            {/* Card 1 - Audience Alignment */}
            <div className="bg-gray-200/50 border border-amber-400 rounded-3xl p-8">
              <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Audience Alignment
              </h3>
              <p className="text-black text-base leading-relaxed">
                Different audiences consume content through different channels. Your approach must meet customers where they already are.
              </p>
            </div>

            {/* Card 2 - Resource Optimization */}
            <div className="bg-gray-200/50 border border-amber-400 rounded-3xl p-8">
              <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Resource Optimization
              </h3>
              <p className="text-black text-base leading-relaxed">
                Each model requires different budget allocations. Choosing wisely ensures maximum ROI for your investment.
              </p>
            </div>

            {/* Card 3 - Scalability Potential */}
            <div className="bg-gray-200/50 border border-amber-400 rounded-3xl p-8">
              <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Scalability Potential
              </h3>
              <p className="text-black text-base leading-relaxed">
                Some approaches scale better than others. Understanding this helps plan for sustainable growth.
              </p>
            </div>

            {/* Card 4 - Timeline Expectations */}
            <div className="bg-gray-200/50 border border-amber-400 rounded-3xl p-8">
              <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Timeline Expectations
              </h3>
              <p className="text-black text-base leading-relaxed">
                Different models deliver results at different speeds. Align your approach with business timeline needs.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Traditional Marketing Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Traditional Marketing
          </h2>

          {/* First Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-6 max-w-6xl">
            Traditional marketing encompasses time-tested methods that dominated the marketing landscape for decades. These approaches include print advertisements in newspapers and magazines, television and radio commercials, outdoor billboards, direct mail flyers, and physical promotional materials.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-12 max-w-6xl">
            While digital channels have gained prominence, traditional marketing remains relevant for certain demographics and industries. It excels at building local brand awareness, reaching audiences without strong digital engagement, and creating tangible brand experiences. Many businesses find success in hybrid approaches that combine traditional methods with modern techniques.
          </p>

          {/* Three Cards Grid */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 mb-12 sm:mb-20">
            
            {/* Card 1 - Print Advertising */}
            <div className="border-2 border-orange-500 rounded-2xl p-8 bg-black">
              <h3 className="text-2xl font-bold text-white mb-4">
                Print Advertising
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Newspapers, magazines, brochures, and catalogs that place your brand directly in customers' hands.
              </p>
            </div>

            {/* Card 2 - Broadcast Media */}
            <div className="border-2 border-orange-500 rounded-2xl p-8 bg-black">
              <h3 className="text-2xl font-bold text-white mb-4">
                Broadcast Media
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Television and radio commercials that reach mass audiences during peak viewing or listening times.
              </p>
            </div>

            {/* Card 3 - Outdoor Advertising */}
            <div className="border-2 border-orange-500 rounded-2xl p-8 bg-black">
              <h3 className="text-2xl font-bold text-white mb-4">
                Outdoor Advertising
              </h3>
              <p className="text-gray-300 text-base leading-relaxed">
                Billboards, transit ads, and signage that capture attention in high-traffic physical locations.
              </p>
            </div>

          </div>

          {/* Strengths and Considerations Section */}
          <div>
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
              Traditional Marketing: Strengths and Considerations
            </h2>

            <div className="grid lg:grid-cols-2 gap-6 sm:gap-12">
              
              {/* Left Side - Key Advantages */}
              <div>
                <h3 className="text-3xl font-bold text-orange-500 mb-8">
                  Key Advantages
                </h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Tangible presence</span> creates lasting impressions through physical materials
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Broad reach</span> to audiences who may not be digitally active
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Local dominance</span> for community-focused businesses
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Credibility boost</span> from established media channels
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Less competition</span> as many businesses shift purely digital
                    </p>
                  </li>
                </ul>
              </div>

              {/* Right Side - Important Considerations */}
              <div>
                <h3 className="text-3xl font-bold text-orange-500 mb-8">
                  Important Considerations
                </h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Higher costs</span> for production and placement
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Limited tracking</span> makes ROI measurement challenging
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Slower adjustments</span> once campaigns are launched
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Decreasing reach</span> among younger demographics
                    </p>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-orange-500 text-xl mt-1">•</span>
                    <p className="text-gray-300 text-lg leading-relaxed">
                      <span className="font-bold text-white">Longer lead times</span> from concept to execution
                    </p>
                  </li>
                </ul>
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Digital Marketing Intro Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500">
        <div className="max-w-7xl mx-auto">
          
          <div className="bg-black rounded-3xl p-12 lg:p-16">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
              Digital Marketing
            </h2>

            {/* First Paragraph */}
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Digital marketing leverages internet-based channels and technologies to connect with customers where they spend increasing amounts of time—online. This comprehensive approach includes search engine optimization (SEO) to improve organic visibility, pay-per-click (PPC) advertising for immediate traffic, social media marketing across platforms, email campaigns that nurture leads, and content marketing that educates and engages.
            </p>

            {/* Second Paragraph */}
            <p className="text-gray-300 text-lg leading-relaxed">
              The digital landscape offers unprecedented targeting capabilities, allowing businesses to reach specific demographics, interests, and behaviors. Real-time analytics provide immediate feedback on campaign performance, enabling rapid optimization. Digital marketing's flexibility and measurability make it essential for modern businesses, regardless of size or industry. Most importantly, it levels the playing field, allowing smaller companies to compete effectively against larger competitors through strategic, data-driven approaches.
            </p>

          </div>

        </div>
      </section>

      {/* Core Digital Marketing Channels Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-orange-500 mb-12">
            Core Digital Marketing Channels
          </h2>

          {/* Channels Grid - 2 columns */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
            
            {/* Channel 1 - Search Engine Optimization */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full border-2 border-orange-500 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Search Engine Optimization
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Optimize your website and content to rank higher in organic search results, driving qualified traffic without ongoing ad spend.
                </p>
              </div>
            </div>

            {/* Channel 2 - Pay-Per-Click Advertising */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full border-2 border-orange-500 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Pay-Per-Click Advertising
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Place targeted ads on search engines and websites, paying only when users click—delivering immediate, measurable results.
                </p>
              </div>
            </div>

            {/* Channel 3 - Social Media Marketing */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full border-2 border-orange-500 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Social Media Marketing
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Build communities and engage audiences on platforms like Facebook, Instagram, LinkedIn, and TikTok through organic and paid content.
                </p>
              </div>
            </div>

            {/* Channel 4 - Email Campaigns */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full border-2 border-orange-500 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Email Campaigns
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Nurture leads and maintain customer relationships through targeted, personalized messages delivered directly to inboxes.
                </p>
              </div>
            </div>

            {/* Channel 5 - Content Marketing */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full border-2 border-orange-500 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Content Marketing
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Create valuable blogs, videos, podcasts, and resources that attract, educate, and convert your target audience.
                </p>
              </div>
            </div>

            {/* Channel 6 - Mobile Marketing */}
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full border-2 border-orange-500 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Mobile Marketing
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Reach customers on smartphones through apps, SMS campaigns, and mobile-optimized experiences.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Digital Marketing by the Numbers Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-orange-500 mb-10 sm:mb-16 text-center">
            Digital Marketing by the Numbers
          </h2>

          {/* Statistics Grid - 4 columns */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            
            {/* Stat 1 - 68% */}
            <div className="text-center">
              <div className="text-4xl sm:text-6xl lg:text-7xl font-bold text-white mb-3 sm:mb-4">
                68%
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                Online Experiences
              </h3>
              <p className="text-gray-400 text-base">
                Begin with a search engine query
              </p>
            </div>

            {/* Stat 2 - 4.2x */}
            <div className="text-center">
              <div className="text-4xl sm:text-6xl lg:text-7xl font-bold text-white mb-3 sm:mb-4">
                4.2x
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                ROI Potential
              </h3>
              <p className="text-gray-400 text-base">
                Average return on email marketing investment
              </p>
            </div>

            {/* Stat 3 - 87% */}
            <div className="text-center">
              <div className="text-4xl sm:text-6xl lg:text-7xl font-bold text-white mb-3 sm:mb-4">
                87%
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                B2B Marketers
              </h3>
              <p className="text-gray-400 text-base">
                Use content marketing as a core strategy
              </p>
            </div>

            {/* Stat 4 - $5.6T */}
            <div className="text-center">
              <div className="text-4xl sm:text-6xl lg:text-7xl font-bold text-white mb-3 sm:mb-4">
                $5.6T
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                Global E-commerce
              </h3>
              <p className="text-gray-400 text-base">
                Expected online sales by 2027
              </p>
            </div>

          </div>

          {/* Bottom Description */}
          <p className="text-gray-300 text-lg leading-relaxed text-center max-w-5xl mx-auto">
            Digital marketing continues to dominate modern business strategy, with measurable results and unprecedented reach. These statistics underscore why businesses of all sizes are prioritizing digital channels for customer acquisition and retention.
          </p>

        </div>
      </section>

      {/* Inbound Marketing Section */}
      {/* Inbound Marketing Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-indigo-300 rounded-full opacity-20"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Inbound Marketing
          </h2>

          {/* First Paragraph */}
          <p className="text-black text-lg leading-relaxed mb-6 max-w-6xl">
            Inbound marketing represents a customer-centric philosophy that attracts potential customers through valuable content rather than interrupting them with unwanted messages. This approach focuses on creating high-quality blog posts, educational resources, helpful videos, and engaging social media content that addresses customer pain points and answers their questions.
          </p>

          {/* Second Paragraph */}
          <p className="text-black text-lg leading-relaxed mb-16 max-w-6xl">
            The inbound methodology follows a clear framework: attract strangers with relevant content, convert visitors into leads through compelling offers, close leads into customers with targeted nurturing, and delight customers to become promoters of your brand. By providing genuine value throughout the customer journey, inbound marketing builds trust organically and creates sustainable growth.
          </p>

          {/* 4 Stages Grid */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
            
            {/* Stage 1 - Attract */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-orange-500 rounded-2xl p-8 hover:border-orange-400 transition-all duration-300 transform hover:scale-105">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-200 to-orange-600 flex items-center justify-center shadow-lg shadow-orange-500/50">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-3xl font-bold text-white mb-3">
                      Attract
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                      Draw visitors through valuable content
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Stage 2 - Convert */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-orange-500 rounded-2xl p-8 hover:border-orange-400 transition-all duration-300 transform hover:scale-105">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-200 to-orange-600 flex items-center justify-center shadow-lg shadow-orange-500/50">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-3xl font-bold text-white mb-3">
                      Convert
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                      Turn visitors into qualified leads
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Stage 3 - Close */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-orange-500 rounded-2xl p-8 hover:border-orange-400 transition-all duration-300 transform hover:scale-105">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-200 to-orange-600 flex items-center justify-center shadow-lg shadow-orange-500/50">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-3xl font-bold text-white mb-3">
                      Close
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                      Transform leads into customers
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Stage 4 - Delight */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-orange-500 rounded-2xl p-8 hover:border-orange-400 transition-all duration-300 transform hover:scale-105">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-200 to-orange-600 flex items-center justify-center shadow-lg shadow-orange-500/50">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-3xl font-bold text-white mb-3">
                      Delight
                    </h3>
                    <p className="text-gray-300 text-base leading-relaxed">
                      Create promoters and advocates
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Inbound vs. Outbound: A Strategic Comparison Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-amber-200 rounded-full opacity-30"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-12 text-center">
            Inbound vs. Outbound: A Strategic Comparison
          </h2>

          {/* Two Cards Grid */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
            
            {/* Card 1 - Inbound Marketing Approach */}
            <div className="bg-orange-500/90 rounded-3xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <h3 className="text-2xl font-bold text-black">
                  Inbound Marketing Approach
                </h3>
              </div>
              
              <div className="space-y-4">
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Philosophy:</span> Attract customers to you
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Method:</span> Create valuable content that answers customer questions and solves problems
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Customer Experience:</span> Permission-based, welcomed interaction
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Cost Structure:</span> Lower ongoing costs, higher initial investment in content
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Timeline:</span> Longer to build momentum, sustainable long-term results
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Measurement:</span> Detailed analytics on engagement and conversions
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 - Outbound Marketing Approach */}
            <div className="bg-orange-500/90 rounded-3xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                </svg>
                <h3 className="text-2xl font-bold text-black">
                  Outbound Marketing Approach
                </h3>
              </div>
              
              <div className="space-y-4">
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Philosophy:</span> Push messages to prospects
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Method:</span> Broadcast promotional messages through ads, cold calls, and direct mail
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Customer Experience:</span> Interruptive, sometimes unwelcome contact
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Cost Structure:</span> Higher ongoing costs for continued reach
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Timeline:</span> Immediate results, requires continuous investment
                  </p>
                </div>
                
                <div>
                  <p className="text-black text-base">
                    <span className="font-bold">Measurement:</span> Response rates, often harder to track precisely
                  </p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Outbound Marketing Section */}
      <section className="bg-orange-500 relative px-8 lg:px-24 py-20 ">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Outbound Marketing
          </h2>

          {/* First Paragraph */}
          <p className="text-black text-lg leading-relaxed mb-6 max-w-6xl">
            Outbound marketing takes a proactive approach by pushing promotional messages directly to potential customers, whether they've expressed interest or not. This traditional methodology includes cold calling prospects, sending unsolicited direct mail, running display advertisements, broadcasting commercials, and purchasing email lists for promotional campaigns.
          </p>

          {/* Second Paragraph */}
          <p className="text-black text-lg leading-relaxed max-w-6xl">
            While often viewed as interruptive, outbound marketing remains effective for certain business contexts. It delivers immediate visibility, works well for time-sensitive promotions, and can quickly generate awareness for new products or services. B2B companies often find success using targeted outbound strategies, particularly when reaching decision-makers who may not actively search for solutions. The key to modern outbound success lies in improved targeting, personalization, and respecting customer preferences to minimize negative perception while maximizing response rates.
          </p>

        </div>
      </section>

      {/* When Outbound Marketing Makes Sense Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            When Outbound Marketing Makes Sense
          </h2>

          {/* 6 Cards Grid - 2 columns */}
          <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
            
            {/* Card 1 - Product Launches */}
            <div className="relative">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
              </div>
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8 pt-10">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Product Launches
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Quickly generate awareness for new offerings when speed matters more than organic growth.
                </p>
              </div>
            </div>

            {/* Card 2 - Time-Sensitive Offers */}
            <div className="relative">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8 pt-10">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Time-Sensitive Offers
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Promote limited-time deals or seasonal sales that require immediate customer action.
                </p>
              </div>
            </div>

            {/* Card 3 - B2B Decision-Makers */}
            <div className="relative mt-10">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8 pt-10">
                <h3 className="text-2xl font-bold text-white mb-4">
                  B2B Decision-Makers
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Reach executives and buyers who may not actively search for solutions but have budget authority.
                </p>
              </div>
            </div>

            {/* Card 4 - Local Market Saturation */}
            <div className="relative mt-10">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
              </div>
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8 pt-10">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Local Market Saturation
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Dominate specific geographic areas through concentrated advertising and outreach efforts.
                </p>
              </div>
            </div>

            {/* Card 5 - Brand Awareness Campaigns */}
            <div className="relative mt-10">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
              </div>
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8 pt-10">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Brand Awareness Campaigns
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Build recognition in new markets where you lack organic presence or search visibility.
                </p>
              </div>
            </div>

            {/* Card 6 - Competitive Response */}
            <div className="relative mt-10">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                  </svg>
                </div>
              </div>
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8 pt-10">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Competitive Response
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Counter aggressive competitor campaigns with immediate market presence and messaging.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Relationship Marketing Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black overflow-hidden">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Relationship Marketing
          </h2>

          {/* First Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-6 max-w-6xl">
            Relationship marketing prioritizes long-term customer loyalty over short-term transactions. This approach recognizes that retaining existing customers costs significantly less than acquiring new ones, while loyal customers typically spend more and provide valuable referrals. Relationship marketing focuses on continuous engagement through personalized communication, exceptional customer service, loyalty programs, exclusive offers, and community building.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-16 max-w-6xl">
            Successful relationship marketing requires understanding individual customer preferences, purchase history, and behavior patterns. Businesses invest in CRM systems, personalized email sequences, dedicated account management, and customer success programs. The goal extends beyond satisfaction to creating emotional connections and brand advocacy. When customers feel valued and understood, they become partners in your success—providing feedback, defending your brand, and actively promoting your products or services to their networks.
          </p>

          {/* Relationship Journey - Responsive Grid (no hardcoded padding) */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6">
            
            {[
              { title: 'Acquire', sub: 'Welcome new customers', icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" /> },
              { title: 'Engage',  sub: 'Build relationships',   icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /> },
              { title: 'Delight', sub: 'Exceed expectations',  icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /> },
              { title: 'Retain',  sub: 'Maintain loyalty',     icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /> },
              { title: 'Advocate',sub: 'Create promoters',     icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" /> },
            ].map((stage) => (
              <div key={stage.title} className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-500/30 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
                <div className="relative bg-gradient-to-br from-orange-600 to-orange-500 rounded-3xl p-4 sm:p-6 shadow-2xl transform hover:scale-105 transition-all duration-300 h-full">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border-4 border-white/30 mb-3 sm:mb-4">
                      <svg className="w-7 h-7 sm:w-10 sm:h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {stage.icon}
                      </svg>
                    </div>
                    <h3 className="text-lg sm:text-2xl font-bold text-white mb-1 sm:mb-2">{stage.title}</h3>
                    <p className="text-white/90 text-xs sm:text-base">{stage.sub}</p>
                  </div>
                </div>
              </div>
            ))}

          </div>

        </div>
      </section>

      {/* Building Customer Loyalty That Lasts Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-gradient-to-br from-white to-white">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-12 text-center">
            Building Customer Loyalty That Lasts
          </h2>

          {/* Content Grid - Image and Tactics */}
          <div className="grid lg:grid-cols-2 gap-12 items-start mb-12">
            
            {/* Left Side - Image */}
            <div className="relative group w-full max-w-[650px]">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/30 to-cyan-500/30 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="/Assests/home_page_48.png" 
                  alt="Customer working on laptop" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>

            {/* Right Side - Key Tactics */}
            <div>
              <h3 className="text-3xl font-bold text-black mb-6">
                Key Relationship Marketing Tactics
              </h3>
              
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-black rounded-full mt-2"></div>
                  <p className="text-black text-base leading-relaxed">
                    <span className="font-bold">Personalized Communication:</span> Use customer data to tailor messages, offers, and experiences to individual preferences and behaviors
                  </p>
                </li>
                
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-black rounded-full mt-2"></div>
                  <p className="text-black text-base leading-relaxed">
                    <span className="font-bold">Loyalty Programs:</span> Reward repeat purchases and engagement with points, discounts, or exclusive perks that increase lifetime value
                  </p>
                </li>
                
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-black rounded-full mt-2"></div>
                  <p className="text-black text-base leading-relaxed">
                    <span className="font-bold">Exceptional Service:</span> Go beyond problem-solving to create memorable experiences that customers want to share
                  </p>
                </li>
                
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-black rounded-full mt-2"></div>
                  <p className="text-black text-base leading-relaxed">
                    <span className="font-bold">Community Building:</span> Create spaces for customers to connect with each other and your brand, fostering belonging
                  </p>
                </li>
                
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-black rounded-full mt-2"></div>
                  <p className="text-black text-base leading-relaxed">
                    <span className="font-bold">Proactive Outreach:</span> Check in regularly, not just when selling—show genuine interest in customer success
                  </p>
                </li>
                
                <li className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-2 h-2 bg-black rounded-full mt-2"></div>
                  <p className="text-black text-base leading-relaxed">
                    <span className="font-bold">Feedback Loops:</span> Actively solicit and act on customer input, demonstrating that their opinions matter
                  </p>
                </li>
              </ul>
            </div>

          </div>

          {/* Bottom Text */}
          <div className="text-center max-w-5xl mx-auto">
            <p className="text-black text-lg leading-relaxed">
              Research shows that increasing customer retention by just 5% can boost profits by 25-95%. Relationship marketing transforms transactional exchanges into partnerships built on trust, value, and mutual benefit.
            </p>
          </div>

        </div>
      </section>

      {/* Event Marketing Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-gradient-to-br from-orange-500 to-white">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Event Marketing
          </h2>

          {/* First Paragraph */}
          <p className="text-black text-lg leading-relaxed mb-6 max-w-6xl">
            Event marketing creates face-to-face opportunities to showcase products, demonstrate value, and build personal connections with prospects and customers. This approach includes trade shows where industries gather, product launch events that generate buzz, conferences that establish thought leadership, workshops and seminars that educate audiences, and experiential activations that immerse participants in your brand.
          </p>

          {/* Second Paragraph */}
          <p className="text-black text-lg leading-relaxed mb-16 max-w-6xl">
            The power of event marketing lies in its ability to engage multiple senses simultaneously and create memorable experiences. Attendees can see, touch, and try products while interacting directly with brand representatives. These personal connections accelerate trust-building and purchase decisions. Events also generate content opportunities—from social media coverage to post-event nurturing campaigns. While events require significant planning and investment, they deliver concentrated access to highly qualified audiences actively seeking solutions in your space.
          </p>

          {/* Types of Marketing Events */}
          <h3 className="text-3xl lg:text-4xl font-bold text-white mb-10">
            Types of Marketing Events
          </h3>

          {/* 4 Cards Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Card 1 - Trade Shows & Exhibitions */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/30 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
              <div className="relative bg-gradient-to-br from-gray-500 to-orange-500 rounded-3xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300">
                {/* Image */}
                <div className="h-48 overflow-hidden">
                  <img 
                    src="Assests/home_page_49.png" 
                    alt="Trade show booth" 
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Content */}
                <div className="p-6">
                  <h4 className="text-xl font-bold text-white mb-3">
                    Trade Shows & Exhibitions
                  </h4>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Industry gatherings where businesses showcase offerings to concentrated audiences of prospects, partners, and media.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 - Product Launch Events */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/30 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
              <div className="relative bg-gradient-to-br from-gray-500 to-orange-500 rounded-3xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300">
                {/* Image */}
                <div className="h-48 overflow-hidden">
                  <img 
                    src="Assests/home_page_50.png" 
                    alt="Product launch event" 
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Content */}
                <div className="p-6">
                  <h4 className="text-xl font-bold text-white mb-3">
                    Product Launch Events
                  </h4>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Dedicated reveals that generate excitement, media coverage, and initial sales momentum for new offerings.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 - Conferences & Seminars */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/30 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
              <div className="relative bg-gradient-to-br from-gray-500 to-orange-500 rounded-3xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300">
                {/* Image */}
                <div className="h-48 overflow-hidden">
                  <img 
                    src="Assests/home_page_51.png" 
                    alt="Conference presentation" 
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Content */}
                <div className="p-6">
                  <h4 className="text-xl font-bold text-white mb-3">
                    Conferences & Seminars
                  </h4>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Educational gatherings that position your brand as an industry thought leader while building authority.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 - Experiential Activations */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/30 to-transparent rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
              <div className="relative bg-gradient-to-br from-gray-500 to-orange-500 rounded-3xl overflow-hidden shadow-2xl hover:scale-105 transition-all duration-300">
                {/* Image */}
                <div className="h-48 overflow-hidden">
                  <img 
                    src="Assests/home_page_52.png" 
                    alt="Experiential activation" 
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Content */}
                <div className="p-6">
                  <h4 className="text-xl font-bold text-white mb-3">
                    Experiential Activations
                  </h4>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Immersive brand experiences that go beyond traditional advertising — bringing your message to life through interactive installations.
                  </p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Event Marketing Success Metrics Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            Event Marketing Success Metrics
          </h2>

          {/* Bar Chart */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 mb-8">
            <div className="space-y-6">
              
              {/* Bar 1 - Lead Quality */}
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold text-lg">Lead Quality</span>
                  <span className="text-white font-bold text-lg">100</span>
                </div>
                <div className="relative h-10 bg-indigo-900/30 rounded-lg overflow-hidden">
                  <div 
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-900 to-orange-800 rounded-lg transition-all duration-1000"
                    style={{width: '100%'}}
                  ></div>
                </div>
              </div>

              {/* Bar 2 - Attendee Engagement */}
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold text-lg">Attendee Engagement</span>
                  <span className="text-white font-bold text-lg">95</span>
                </div>
                <div className="relative h-10 bg-indigo-900/30 rounded-lg overflow-hidden">
                  <div 
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-800 to-orange-700 rounded-lg transition-all duration-1000 flex items-center justify-center"
                    style={{width: '95%'}}
                  >
                    {/* Tooltip on hover */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                      <div className="bg-indigo-900 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-lg">
                        Success Metric: Attendee Engagement<br/>
                        Importance Rating: 87
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bar 3 - Brand Awareness */}
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold text-lg">Brand Awareness</span>
                  <span className="text-white font-bold text-lg">85</span>
                </div>
                <div className="relative h-10 bg-indigo-900/30 rounded-lg overflow-hidden">
                  <div 
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-700 to-orange-600 rounded-lg transition-all duration-1000"
                    style={{width: '85%'}}
                  ></div>
                </div>
              </div>

              {/* Bar 4 - Direct Sales */}
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold text-lg">Direct Sales</span>
                  <span className="text-white font-bold text-lg">75</span>
                </div>
                <div className="relative h-10 bg-indigo-900/30 rounded-lg overflow-hidden">
                  <div 
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-600 to-orange-500 rounded-lg transition-all duration-1000"
                    style={{width: '75%'}}
                  ></div>
                </div>
              </div>

              {/* Bar 5 - Social Media Reach */}
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold text-lg">Social Media Reach</span>
                  <span className="text-white font-bold text-lg">70</span>
                </div>
                <div className="relative h-10 bg-indigo-900/30 rounded-lg overflow-hidden">
                  <div 
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-500 to-orange-400 rounded-lg transition-all duration-1000"
                    style={{width: '70%'}}
                  ></div>
                </div>
              </div>

              {/* Bar 6 - Content Generated */}
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold text-lg">Content Generated</span>
                  <span className="text-white font-bold text-lg">60</span>
                </div>
                <div className="relative h-10 bg-indigo-900/30 rounded-lg overflow-hidden">
                  <div 
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-400 to-orange-300 rounded-lg transition-all duration-1000"
                    style={{width: '60%'}}
                  ></div>
                </div>
              </div>

              {/* Bar 7 - Partnership Opportunities */}
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-white font-semibold text-lg">Partnership Opportunities</span>
                  <span className="text-white font-bold text-lg">55</span>
                </div>
                <div className="relative h-10 bg-indigo-900/30 rounded-lg overflow-hidden">
                  <div 
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-orange-300 to-orange-200 rounded-lg transition-all duration-1000"
                    style={{width: '55%'}}
                  ></div>
                </div>
              </div>

            </div>

            {/* X-axis labels */}
            <div className="flex justify-between mt-4 px-2">
              <span className="text-white font-semibold">0</span>
              <span className="text-white font-semibold">40</span>
              <span className="text-white font-semibold">80</span>
              <span className="text-white font-semibold">120</span>
            </div>
          </div>

          {/* Bottom Text */}
          <div className="text-center max-w-5xl mx-auto">
            <p className="text-white text-lg leading-relaxed">
              Event marketers prioritize lead quality over quantity, recognizing that face-to-face interactions produce warmer prospects more likely to convert. Engagement levels during events serve as strong indicators of future purchase intent and brand affinity.
            </p>
          </div>

        </div>
      </section>

      {/* Guerrilla Marketing Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Guerrilla Marketing
          </h2>

          {/* First Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-6 max-w-6xl">
            Guerrilla marketing thrives on creativity, surprise, and unconventional tactics that capture attention without massive budgets. This approach emerged as a way for small businesses to compete with larger competitors through bold, memorable campaigns that generate buzz and word-of-mouth. Examples include flash mobs, street art installations, creative stunts, viral videos, ambush marketing, and unexpected brand placements that catch audiences off guard.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed max-w-6xl">
            The beauty of guerrilla marketing lies in its ability to achieve outsized impact with limited resources. A clever idea executed at the right moment can generate millions of impressions through organic sharing and media coverage. These campaigns work best when they're authentic, relevant to your brand, and provide genuine entertainment or value. The risk is that guerrilla tactics can backfire if perceived as intrusive or tone-deaf, so careful planning and understanding of your audience are essential.
          </p>

        </div>
      </section>

      {/* Guerrilla Marketing Principles Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 min-h-screen flex items-center">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img 
            src="Assests/home_page_53.png" 
            alt="Event crowd background" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        </div>

        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-10">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-30"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-20 w-full">
          
          {/* Main Container with backdrop blur */}
          <div className="bg-black/40 backdrop-blur-md rounded-3xl p-8 lg:p-12 border border-white/10">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
              Guerrilla Marketing Principles
            </h2>

            {/* 4 Principle Cards Grid - 2x2 */}
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              
              {/* Card 1 - Maximum Creativity */}
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                <div className="relative bg-black/60 backdrop-blur-sm border border-blue-500/30 rounded-2xl p-6 hover:border-blue-500/60 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-white mb-3">
                        Maximum Creativity
                      </h3>
                      <p className="text-gray-300 text-base leading-relaxed">
                        Original ideas that surprise and delight, breaking through advertising clutter with unexpected approaches.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 2 - Minimal Investment */}
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                <div className="relative bg-black/60 backdrop-blur-sm border border-blue-500/30 rounded-2xl p-6 hover:border-blue-500/60 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-white mb-3">
                        Minimal Investment
                      </h3>
                      <p className="text-gray-300 text-base leading-relaxed">
                        Achieve big impact with small budgets by leveraging imagination over advertising spend.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 3 - Viral Potential */}
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                <div className="relative bg-black/60 backdrop-blur-sm border border-blue-500/30 rounded-2xl p-6 hover:border-blue-500/60 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-white mb-3">
                        Viral Potential
                      </h3>
                      <p className="text-gray-300 text-base leading-relaxed">
                        Create shareable moments that audiences want to photograph, discuss, and spread organically.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 4 - Strategic Timing */}
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
                <div className="relative bg-black/60 backdrop-blur-sm border border-blue-500/30 rounded-2xl p-6 hover:border-blue-500/60 transition-all duration-300">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-white mb-3">
                        Strategic Timing
                      </h3>
                      <p className="text-gray-300 text-base leading-relaxed">
                        Execute campaigns at moments and locations where target audiences are most receptive.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* Bottom Text */}
            <div className="text-center max-w-5xl mx-auto mt-8">
              <p className="text-gray-300 text-base leading-relaxed">
                Successful guerrilla marketing requires courage to try unconventional approaches while maintaining brand authenticity. The most effective campaigns create experiences so remarkable that people can't help but talk about them.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Choosing Your Marketing Model: A Strategic Framework Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        {/* Background stars effect */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(80)].map((_, i) => (
            <div
              key={i}
              className="absolute bg-white rounded-full opacity-50"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
              }}
            />
          ))}
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Choosing Your Marketing Model: A Strategic Framework
          </h2>

          {/* Intro Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-12 max-w-6xl">
            The most successful marketing strategies don't rely on a single approach—they blend multiple models strategically based on business goals, target audiences, and available resources. Consider these factors when building your marketing mix:
          </p>

          {/* 6 Framework Points Grid - 2 columns */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8 mb-8 sm:mb-12">
            
            {/* Point 01 - Assess Your Audience */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative">
                {/* Number and Title */}
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-5xl font-bold text-orange-500/30">01</span>
                  <div className="flex-1 h-px bg-gradient-to-r from-orange-500 to-transparent"></div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Assess Your Audience
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Where do they spend time? How do they prefer to consume information? What builds trust with them?
                </p>
              </div>
            </div>

            {/* Point 02 - Define Your Goals */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative">
                {/* Number and Title */}
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-5xl font-bold text-orange-500/30">02</span>
                  <div className="flex-1 h-px bg-gradient-to-r from-orange-500 to-transparent"></div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Define Your Goals
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Are you building awareness, generating leads, nurturing loyalty, or driving immediate sales?
                </p>
              </div>
            </div>

            {/* Point 03 - Evaluate Resources */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative">
                {/* Number and Title */}
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-5xl font-bold text-orange-500/30">03</span>
                  <div className="flex-1 h-px bg-gradient-to-r from-orange-500 to-transparent"></div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Evaluate Resources
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  What budget, team capacity, and timeline do you have available for marketing initiatives?
                </p>
              </div>
            </div>

            {/* Point 04 - Test and Measure */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative">
                {/* Number and Title */}
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-5xl font-bold text-orange-500/30">04</span>
                  <div className="flex-1 h-px bg-gradient-to-r from-orange-500 to-transparent"></div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Test and Measure
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Start with small experiments, track results rigorously, and scale what works effectively.
                </p>
              </div>
            </div>

            {/* Point 05 - Integrate Approaches */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative">
                {/* Number and Title */}
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-5xl font-bold text-orange-500/30">05</span>
                  <div className="flex-1 h-px bg-gradient-to-r from-orange-500 to-transparent"></div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Integrate Approaches
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Combine complementary models that reinforce each other and create cohesive customer experiences.
                </p>
              </div>
            </div>

            {/* Point 06 - Adapt Continuously */}
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-transparent rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300"></div>
              <div className="relative">
                {/* Number and Title */}
                <div className="flex items-center gap-4 mb-4">
                  <span className="text-5xl font-bold text-orange-500/30">06</span>
                  <div className="flex-1 h-px bg-gradient-to-r from-orange-500 to-transparent"></div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">
                  Adapt Continuously
                </h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Monitor performance, stay current with trends, and adjust your mix as markets and audiences evolve.
                </p>
              </div>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <div className="max-w-6xl mx-auto">
            <p className="text-gray-300 text-lg leading-relaxed">
              Remember that the best marketing model is one that aligns with your unique business context while remaining flexible enough to evolve. Start with approaches that match your strengths and audience needs, measure results honestly, and refine continuously. Success comes not from following a single prescribed model, but from thoughtfully orchestrating multiple approaches into a coherent strategy that delivers sustainable growth.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
}

export default MarketingApproach;